module.exports = __webpack_public_path__ + "static/media/document_load_object.6d761e86.svg";